<template>
  <div>
    <z-mantenedor
      v-model="items"
      :campo-subtitulo-dialog="(factor2c) => factor2c.ano"
      :campo-titulo-dialog="(factor2c) => 'Factor segundas cuotas'"
      :headers="headers"
      :query="query"
      url="/pagos/factores2c"
      search-url="/pagos/factores2c/search"
      search-method="post"
      disable-delete
      disable-view
      height="380"
      search-inicial
      :on-before-save="beforeSave"
      width="700"
      @created="$emit('notificar', 'El Factor fue creado')"
      @created:error="$emit('notificar:error', 'Error al intentar crear Factor.')"
      @updated="$emit('notificar', 'Factor guardado.')"
      @update:error="$emit('notificar:error', 'Error al intentar guardar.')"
    >
      <template #buscador="{ loading, search, create }">
        <v-form @submit.prevent="search">
          <v-card class="d-flex justify-space-between" flat>
            <v-select v-model="query.filter.ano" :items="anos" dense label="Año" outlined />
            <v-spacer />
            <z-btn :loading="loading" class="mx-1" color="primary" outlined :disabled="!fechaBusqueda" @click="buscarAutomaticamente()"> Buscar valor ipc </z-btn>
            <z-btn :loading="loading" color="primary" outlined type="submit"> Actualizar </z-btn>
            <z-btn
              class="mx-1"
              :loading="loading"
              color="primary"
              outlined
              @click="create({ ano: anoActual, factor: '', tramite_id: '' })"
            >
              Crear
            </z-btn>

          </v-card>
          <v-card class="d-flex justify-space-between" flat>
            <v-date-picker v-model="fechaBusqueda" type="month" :show-current="true"></v-date-picker>
            <div v-if="busquedaIpcAutomaticaExitosa === false" class="text-right">
              <h3 class="py-2" style="color: red; margin-right: 20px;">{{ mensajeError }}</h3>
            </div>
            <div v-if="busquedaIpcAutomaticaExitosa === true">
              <h3 class="py-2" style="color: green; margin-right: 20px;">
                Valor IPC encontrado: {{ valorIpcEncontrado }} con fecha ({{ fechaIpcEncontrado }})
              </h3>
              <z-btn
                class="mx-1"
                :loading="loading"
                color="primary"
                outlined
                @click="create({ ano: encontrarAno(fechaIpcEncontrado), factor: formatoConPunto(valorIpcEncontrado), tramite_id: '' })"
              >
                Crear usando el valor encontrado
              </z-btn>
            </div>
          </v-card>
        </v-form>
      </template>

      <template #form="{ accion, form, errors }">
        <v-row>
          <v-col>
            <input-tramite
              v-model="form.tramite_id"
              campo="id"
              :filter="
                (t) =>
                  [
                    'permisos-de-circulacion',
                    'permisos-de-circulacion-locomocion-colectiva',
                    'permisos-de-circulacion-pesados',
                  ].includes(t.slug)
              "
              :disabled="accion !== 'create'"
              :error-messages="errors.tramite_id"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="form.ano"
              :error-messages="errors.ano"
              type="number"
              label="Año"
              :max="anoActual"
              :min="anoActual"
              outlined
              :disabled="true"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.factor"
              :error-messages="errors.factor"
              label="Factor"
              minlength="1"
              type="number"
              outlined
              hint="Para ingresar números decimales debes utilizar como separador el punto(.) y no la coma(,). Ejemplo: 5.7"
            />
          </v-col>
        </v-row>
      </template>
    </z-mantenedor>
  </div>
</template>

<script>
import ZBtn from '@/components/ZBtn'
import ZMantenedor from '@/components/ZMantenedor'
import InputTramite from '@/components/Input/InputTramite'

export default {
  components: { ZMantenedor, ZBtn, InputTramite },
  data() {
    return {
      items: [],
      slugTramite: '',
      headers: [
        {
          text: 'Año',
          value: 'ano',
        },
        {
          text: 'Trámite',
          value: 'tramite_id',
          formatter: (v) => this.$tramites.find((t) => t.id === v).nombre,
        },
        {
          text: 'Factor',
          value: 'factor',
          formatter: (v) => !v ? 0 : +('' + v).replace(',', '.'),
        },
        {
          text: 'Última edición',
          value: 'updated_at',
          formatter: (v) => this.$dayjs(v).format('L LT'),
        },
      ],
      query: {
        filter: { ano: this.anoActual },
        sort: {
          0: { field: 'id', direction: 'desc' },
        },
      },
      valorIpcEncontrado: null,
      fechaIpcEncontrado: null,
      busquedaIpcAutomaticaExitosa: null,
      fechaBusqueda: null,
      mensajeError: '',
    }
  },
  computed: {
    anoActual() {
      return parseInt(this.$dayjs().format('YYYY'))
    },
    anos() {
      const anos = []
      for (let ano = this.anoActual - 1; ano <= this.anoActual + 1; ano++) {
        anos.push(ano)
      }
      return anos
    },
  },
  beforeMount() {
    this.query.filter.ano = this.anoActual
  },
  methods: {
    beforeSave(factor2c, accion, form) {
      console.log(this.$tramites)
      console.log(factor2c)
      // factor2c.tramite_id = this.$tramites.find((t) => t.id === Number(factor2c.tramite_id)).id
    },
    fechaFormateada(fecha) {
      return this.$dayjs(fecha).format('DD-MM-YYYY')
    },
    encontrarAno(fecha) {
      return this.$dayjs(fecha).format('YYYY')
    },
    formatoConPunto(numero) {
      return +('' + numero).replace(',', '.')
    },
    async buscarAutomaticamente() {
      const [anio, mes] = this.fechaBusqueda.split('-')

      this.loading = true
      try {
        const url = `pagos/ipc-cmf/${anio}/${mes}`
        const response = await this.$axios.get(url);

        const respuestaConsulta = response.data.data;
        const ipcs = respuestaConsulta.IPCs || []
        if (ipcs.length <= 0) {
          this.valorIpcEncontrado = null
          this.fechaIpcEncontrado = null
          this.busquedaIpcAutomaticaExitosa = false
          this.mensajeError = 'No hay datos para la fecha seleccionada'
          return
        }
        this.valorIpcEncontrado = ipcs[0].Valor.replace('.', '')
        this.fechaIpcEncontrado = this.fechaFormateada(ipcs[0].Fecha)
        this.busquedaIpcAutomaticaExitosa = true
      } catch (error) {
        this.valorIpcEncontrado = null
        this.fechaIpcEncontrado = null
        this.busquedaIpcAutomaticaExitosa = false

        this.mensajeError = 'Error al buscar el IPC'
        if (error.response && error.response.status === 404) {
          this.mensajeError = 'No hay datos para la fecha seleccionada'
        }

      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
